export interface ClientDestinationDetails {
  title: string;
  trx: string;
  notificationId: string;
  blockchain: string;
  destinationPublicKey: string;
  verifiedLabel: string;
  destinationType: DestinationType;
  state: string;
}

export enum DestinationType {
  WITHDRAWAL = 'WITHDRAWAL',
  NEWOWNER_PUBLICKEY = 'NEWOWNER_PUBLICKEY',
  TRANSACTION_SENDER = 'TRANSACTION_SENDER'
}
